import React from 'react'
import { Link } from "react-router-dom";


const Orthopedic = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>ऑर्थोपेडिक</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                <li className="breadcrumb-item">ऑर्थोपेडिक</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>

       <section className="content-inner" style={{ marginTop: "-10px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_04.webp" alt="/" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-inner service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 single-inner order-lg-1">
              <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                <img src="./assets/img/Orthopedics.webp" alt className="object-fit-cover" />
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <h2>ऑर्थोपेडिक्स और जॉइंट रिप्लेसमेंट</h2>
                <p>जब ज़रूरी होता है, तो हम मरीज़ की हड्डियों और जोड़ों की समस्याओं को ठीक करने के लिए सभी मेडिकल, फिजिकल और रिहैबिलिटेटिव तकनीकों का इस्तेमाल करके प्रोसीजर करते हैं। हम हिप, घुटने, कंधे और कोहनी के जोड़ों के रिप्लेसमेंट के कई ऑपरेशन करते हैं। हम सभी मांसपेशियों, लिगामेंट और टेंडन की चोटों के साथ-साथ हड्डियों के बेसिक और कॉम्प्लेक्स फ्रैक्चर का भी इलाज करते हैं। हम बच्चों की चोटों का भी इलाज करते हैं और डिफॉर्मिटी को ठीक करते हैं। हम आर्थराइटिस और उम्र से जुड़ी दूसरी समस्याओं का भी इलाज करते हैं।</p>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ अत्याधुनिक दूरबीन पद्धति द्वारा कम चींड-फाड़ में घुटनें, कंधे एवं रीढ़ की हड्डी के ऑपरेशन</li>
                  <li>  ✅ अत्याधुनिक तकनीक द्वारा जोड़ प्रत्यारोपण (JOINT REPLACEMENT)</li>
                  <li>  ✅ कंधे के दर्द में PRP के एक इंजेक्शन से हमेशा के लिए आराम</li>
                  <li>  ✅ एड़ी के दर्द में PRP के एक इंजेक्शन से हमेशा के लिए आराम</li>
                  <li>  ✅ सभी तरीके के टॉमा फैक्चर जैसे रीढ़ की हड्डी, हाथ, पैर के ऑपरेशन</li>
                  <li>  ✅ कमर एवं रीढ़ की हड्‌डी का दर्द </li>
                  <li>  ✅ एड़ी के दर्द में PRP के एक इंजेक्शन से हमेशा के लिए आराम</li>
                  <li>  ✅ घुटनों में दर्द एवं सूजन</li>
                  <li>  ✅ चलने में लड़खड़ाना</li>
                  <li>  ✅ घुटनों में पानी भरना</li>
                  <li>  ✅ पुराने फ्रेक्चर का न जुड़ना</li>
                  <li>  ✅ सामान्य एवं जटिल फ्रेक्चर</li>
                  <li>  ✅ समस्त प्रकार के जोड़ों से संबंधित रोग</li>
                  <li>  ✅ कुल्हे एवं घुटने का दर्द</li>

                </ul>
              </div>
              <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                <h3>ऑर्थोपेडिक इलाज के प्रकार</h3>
                <b style={{ color: "black" }}>1. बिना सर्जरी वाले इलाज (पहला तरीका)</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ दवाएँ (दर्द कम करने वाली और सूजन-रोधी दवाएँ)</li>
                  <li>  ✅ फिजियोथेरेपी और रिहैबिलिटेशन</li>
                  <li>  ✅ व्यायाम के प्रोग्राम</li>
                  <li>  ✅ ब्रेस, कास्ट और सपोर्ट</li>
                  <li>  ✅ जोड़ों में इंजेक्शन (स्टेरॉयड, PRP)</li>
                  <li>  ✅ जीवनशैली में बदलाव (बैठने-उठने का तरीका, वज़न पर कंट्रोल)</li>

                </ul>
                <b style={{ color: "black" }}>2. सर्जरी वाले इलाज (जब ज़रूरत हो)</b>
                <ul className="text-secondary grid-2 m-b30">
                  <li>  ✅ जोड़ बदलना (घुटना, कूल्हा, कंधा)</li>
                  <li>  ✅ आर्थ्रोस्कोपी (कम चीर-फाड़ वाली सर्जरी)</li>
                  <li>  ✅ हड्डी टूटने का इलाज (प्लेट, स्क्रू, रॉड)</li>
                  <li>  ✅ रीढ़ की हड्डी की सर्जरी (स्लिप डिस्क, स्पाइनल फ्यूजन)</li>
                  <li>  ✅ लिगामेंट की मरम्मत (ACL, रोटेटर कफ)</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 m-b30">
              <aside className="side-bar sticky-top left">
                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                  <div className="widget-title">
                    <h4 className="title">सभी सेवाएँ</h4>
                  </div>
                  <ul>
                    <li className="active"><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                    <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                    <li ><Link to="/urology">यूरोलॉजी</Link></li>
                    <li ><Link to="/dermatology">डर्मेटोलॉजी</Link></li>
                    <li ><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                    <li><Link to="/ent">कान, नाक और गले</Link></li>
                    <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                    <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                    <li><Link to="/dental">डेंटल</Link></li>
                    <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                    <li><Link to="/gynaecology">ऑब्सटेट्रिक्स और गायनेकोलॉजी</Link></li>
                    <li><Link to="/paediatrics">पीडियाट्रिक्स</Link></li>
                  </ul>
                </div>
                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                  <div className="widget-content">
                    <img src="./assets/images/question.png" width={80} alt />
                    <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                    <div className="phone-number">
                      <a href="tel:+919165155945">+91 9165155945</a>
                    </div>
                    <div className="email">
                      <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                        @gmail.com</a>
                    </div>
                    <div className="link-btn">
                      <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                        Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>


      <section className="content-inner" style={{ marginTop: "-90px" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_01.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_02.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_03.webp" alt="/" />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="dz-team style-1 box-hover">
                <div className="dz-media">
                  <img src="./assets/img/Orthopedic_04.webp" alt="/" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    </>
  )
}

export default Orthopedic